import styled from 'styled-components';

export const AccountManagementContainer = styled.ul`
    list-style: none;
    margin-inline: 0px;
    padding-inline: 0px;
    margin-block: 0px;
    padding: 0px;
    margin: 0px;
    height: 100%;
`;
